import type { Attributes, Extensions } from '@tiptap/core';
import Link from '@tiptap/extension-link';
import StarterKit from '@tiptap/starter-kit';

/** An http(s) address or a single-slash site path (`//host` is another site, which the server strips). */
export const FOOTER_HREF_RE = /^(https?:\/\/|\/(?!\/))/i;

/** A link that carries its `href` only: the server keeps `a[href]` and strips anything else (target, rel, class),
 *  so a default `target="_blank"` would earn an html-stripped warning on every save. */
const FooterLink = Link.extend({
  addAttributes() {
    const parent: Attributes = this.parent?.() ?? {};
    const { href } = parent;
    return href ? { href } : {};
  },
});

/**
 * The footer text editor's schema, which IS the hub's allowlist: H2/H3, paragraphs, bold, italic, lists, breaks and
 * links (see `FOOTER_ALLOWED_TAGS`). Anything else pasted in is dropped or flattened to text by the parser, so the
 * HTML the editor emits never holds a tag the server would strip.
 */
export const footerEditorExtensions = (): Extensions => [
  StarterKit.configure({
    heading: { levels: [2, 3] },
    code: false,
    codeBlock: false,
    blockquote: false,
    strike: false,
    horizontalRule: false,
  }),
  FooterLink.configure({
    openOnClick: false,
    autolink: false,
    linkOnPaste: false,
    HTMLAttributes: { target: null, rel: null, class: null },
    isAllowedUri: (url) => FOOTER_HREF_RE.test(url),
  }),
];
